import styled from "@emotion/styled";
import React from "react";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import AnimatedModal from "../AnimatedModal";
import { AppButton } from "../Generic/AppButton";

export interface DutySheetCompletedModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
}

const DutySheetCompletedModal = (props: DutySheetCompletedModalProps) => {
  const title = (
    <DutySheetCompletedModal.Title>
      {translate(STRINGS.DUTIES_COMPLETED_SUCCESSFULLY)}
    </DutySheetCompletedModal.Title>
  );

  const actions = (
    <AppButton variant="filled" color="primary" onClick={props.onRequestClose}>
      {translate(STRINGS.OK)}
    </AppButton>
  );

  return (
    <AnimatedModal
      actions={actions}
      animation={<DutySheetCompletedModal.Root />}
      animationOffset={50}
      headline={title}
      isOpen={props.isOpen}
      message={""}
      onRequestClose={props.onRequestClose}
    />
  );
};

DutySheetCompletedModal.Root = styled.div`
  background: url("../assets/duties-submitted.svg") no-repeat center center / cover;
  border-radius: 16px;
  overflow: hidden;
  height: 295px;
`;

DutySheetCompletedModal.Title = styled.div`
  font-size: 18px;
`;

export default DutySheetCompletedModal;
